import { io } from 'socket.io-client';
const socket = io(process.env.REACT_APP_DOCUMENT_GENERATOR_API, {
  autoConnect: false,
  reconnection: false,
  maxHttpBufferSize: 10 * 1024 * 1024,
});
export default socket;
